import { Box, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogComponent from "../../../../../common/components/functional/dialogs/DialogComponent";
import DialogContentWrapper from "../../../../../common/components/functional/dialogs/DialogContentWrapper";
import { useConfirmationDialog } from "../../../../../contexts/ConfirmationDialogContext";
import { AssignmentById } from "../../../../talents/talentAPI";
import { AssignmentRow } from "./AssignmentRow";
import { TargetedShiftInfoText } from "./styles";

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (assignmentId: string) => void;
  selectedAssignmentId: string;
  assignmentOptions: AssignmentById[];
};

export const AssignmentSelectDialog = ({
  open,
  onClose,
  onSave,
  selectedAssignmentId,
  assignmentOptions,
}: Props) => {
  const { t } = useTranslation(["common", "talentProfile"]);
  const { confirm } = useConfirmationDialog();

  const [selected, setSelected] = useState<string>(selectedAssignmentId);
  const saveDisabled = !selected;

  const handleSave = () => {
    onSave(selected);
    onClose();
  };

  const handlePreSave = async () => {
    const previousOrgId = assignmentOptions.find(
      (a) => a.assignmentId === selectedAssignmentId,
    )?.details.customerOrgId;
    const newOrgId = assignmentOptions.find((a) => a.assignmentId === selected)
      ?.details.customerOrgId;

    if (previousOrgId && newOrgId && previousOrgId !== newOrgId) {
      const confirmed = await confirm({
        title: t("talentProfile:targetedShifts.organizationChanged"),
        contentText: t("talentProfile:targetedShifts.organizationChangedInfo"),
        confirmText: t("common:continue"),
      });
      if (confirmed) handleSave();
    } else {
      handleSave();
    }
  };

  useEffect(() => {
    setSelected(selectedAssignmentId);
  }, [selectedAssignmentId]);

  return (
    <DialogComponent
      open={open}
      onClose={onClose}
      sx={{ maxWidth: "1000px" }}
      dragHandleSelector="assignment-select-dialog"
    >
      <DialogContentWrapper
        title={t("talentProfile:targetedShifts.selectDefaultAssignment")}
        onCancel={onClose}
        onSave={handlePreSave}
        saveDisabled={saveDisabled}
        margin
        childContainerSx={{ fontSize: 14 }}
      >
        <RadioGroup sx={{ paddingLeft: 2, width: "100%" }}>
          {assignmentOptions.map((assignment) => (
            <Box display="flex" alignItems="center" width="100%">
              <>
                <FormControlLabel
                  value={assignment.assignmentId}
                  control={
                    <Radio checked={selected === assignment.assignmentId} />
                  }
                  label=""
                  onClick={() => setSelected(assignment.assignmentId)}
                />
              </>
              <AssignmentRow
                key={assignment.assignmentId}
                assignment={assignment}
                canEdit={false}
                openSelectDialog={() => {}}
              />
            </Box>
          ))}
        </RadioGroup>
        <Grid item xs={12}>
          <TargetedShiftInfoText sx={{ padding: "0px 16px 0px 4px" }}>
            {t("talentProfile:targetedShifts.assignmentSelectInfoText")}
          </TargetedShiftInfoText>
        </Grid>
      </DialogContentWrapper>
    </DialogComponent>
  );
};
